// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { INotificationInfo } from '@app/services/notifications/notification.service';
import { environment } from '@app/environments/environment';
import { DXCTIME_NOTIFICATION_SERVICE_CONSTS } from '@app/config/constants';

export interface IDxcTimeNotification {
  id: string;
  count: number;
  isRead: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DxcTimeNotificationService extends ApiService {
  private NOTIFICATIONS_URL = environment.DEPS.NOTIFICATIONS_API.URL;
  consts = DXCTIME_NOTIFICATION_SERVICE_CONSTS;

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  getNotifications(employeeId: string): Observable<INotificationInfo> {
    return this.get<IDxcTimeNotification>(`${this.NOTIFICATIONS_URL}/notifications/dxctime/${employeeId}`).pipe(
      switchMap((notifications) => {
        return notifications.isRead
          ? of(null as INotificationInfo)
          : of({
              title: this.consts.TITLE,
              link: this.consts.LINK,
              message: this.consts.MESSAGE(notifications.count),
              count: notifications.count,
              actionNeeded: true,
              origObj: notifications
            });
      })
    );
  }

  markNotificationAsRead(employeeId: string): Observable<void> {
    return this.post(`${this.NOTIFICATIONS_URL}/notifications/dxctime/${employeeId}`, null);
  }
}
